import { useEffect, useMemo, useState } from "react";

export const CLIENT_PAGE_SIZES = [5, 10, 25, 50, 100];

export function paginateRows(rows, page, pageSize) {
  const total = rows.length;
  const all = pageSize === "all";
  const size = all ? Math.max(total, 1) : Number(pageSize) || 10;
  const totalPages = all ? 1 : Math.max(1, Math.ceil(total / size));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = total === 0 ? 0 : (safePage - 1) * size;
  const end = all ? total : Math.min(start + size, total);
  return {
    total,
    totalPages,
    safePage,
    start,
    end,
    pageRows: all ? rows : rows.slice(start, end),
    showingFrom: total === 0 ? 0 : start + 1,
    showingTo: end,
  };
}

/** Client-side pagination state for row tables (admin, program, journey data). */
export function useClientPagination(rows, { defaultPageSize = 10, resetKeys = [] } = {}) {
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, rows.length, ...resetKeys]);

  const pagination = useMemo(
    () => paginateRows(rows, page, pageSize),
    [rows, page, pageSize],
  );

  return { page, setPage, pageSize, setPageSize, pagination };
}
